import React from 'react';
import { connectivity_colour_lookup, colour_lookup } from './Colours';
import { isUndefinedOrNull } from '../../lib/typeCheck';
import { Icon } from '@iconify/react';

import connectionIcon from '@iconify/icons-icomoon-free/connection';
import disconnectedSolid from '@iconify/icons-clarity/disconnected-solid';
import lightningFill from '@iconify/icons-bi/lightning-fill';
import batteryHalf from '@iconify/icons-bi/battery-half';

const getConnectivityIcon = (online_status) => {
  if (isUndefinedOrNull(online_status)) return disconnectedSolid;
  
  if (online_status === 'offline' || online_status === 'not_measuring') {
    return disconnectedSolid;
  } else {
    return connectionIcon;
  }
}

export const ConnectivityIcon = ({ onlineStatus, translate={x:0,y:0} }: { onlineStatus: any; translate?: any; }) => {
  return (
    <g transform={`translate(${translate.x},${translate.y})`}>
      <circle cx='15' cy='15' r='15' fill='#fff' style={{filter: 'url(#shadowSmall)'}}/>
      <circle transform='translate(1, 1)' cx='14' cy='14' r='14' fill={connectivity_colour_lookup(onlineStatus)}/>
      <circle transform='translate(5, 5)' cx='10' cy='10' r='10' fill='#FFF'/>
      <g transform='translate(7.5,7.5)'>
        <Icon color={connectivity_colour_lookup(onlineStatus)} width='15px' height='15px' icon={getConnectivityIcon(onlineStatus)}/>
      </g>
    </g>
  )
}

export const ExceedancesIcon = ({ totalTimebaseColour, currentTimebaseColour, translate={x:0,y:0} }: { totalTimebaseColour: string; currentTimebaseColour: string; translate?: any; }) => {
  return (
    <g transform={`translate(${translate.x},${translate.y})`}>
      <circle cx='15' cy='15' r='15' fill='#fff' style={{filter: 'url(#shadowSmall)'}}/>
      <circle transform='translate(1, 1)' cx='14' cy='14' r='14' fill={colour_lookup(totalTimebaseColour)}/>
      <circle transform='translate(5, 5)' cx='10' cy='10' r='10' fill={colour_lookup(currentTimebaseColour)}/>
    </g>
  )
}

export const BatteryIcon = ({ chargeStatus, translate={x:0,y:0} }: { chargeStatus: string; translate?: any; }) => {
  return (
    <g transform={`translate(${translate.x},${translate.y})`}>
      <circle cx='15' cy='15' r='15' fill='#fff' style={{filter: 'url(#shadowSmall)'}}/>
      <circle transform='translate(1, 1)' cx='14' cy='14' r='14' fill={colour_lookup(chargeStatus)}/>
      <circle transform='translate(5, 5)' cx='10' cy='10' r='10' fill='#FFF'/>
      <g transform='translate(7.5,7.5)'>
        <Icon color={colour_lookup(chargeStatus)} width='15px' height='15px' icon={lightningFill}/>
      </g>
    </g>
  )
}

export const TunnelIcon = ({ tunnelStatus, translate={x:0,y:0} }: { tunnelStatus: string; translate?: any; }) => {
  return (
    <g transform={`translate(${translate.x},${translate.y})`}>
      <circle cx='15' cy='15' r='15' fill='#fff' style={{filter: 'url(#shadowSmall)'}}/>
      <g transform='translate(5,5)'>
        <Icon color={colour_lookup('grey')} width='20px' height='20px' icon={batteryHalf}/>
      </g>
    </g>
  )
}
